<template>
  <zt-modal :fullscreen="isMobile" :active="visible" :title="$t('message.loginComponent.login.helpTitle')"
    @close="closeDialog" max-width="600px">
    <div class="modal-help-body">
      <div class="bg-white shadow-md rounded-md overflow-hidden">
        <div class="text-zt-dark-500 font-bold text-lg shadow-md py-3 px-6">
          {{ $t("message.loginComponent.login.helpFaq5") }}
        </div>
        <div class="px-6 py-4">
          <div class="text-zt-dark-500">
            En
            <a href="https://www.sichern.com/" target="_blank" rel="noopener noreferrer"
              class="text-blue-500">sichern.com.ar</a>
            {{ $t("message.loginComponent.login.helpAnswer511") }}<br />
            {{ $t("message.loginComponent.login.helpAnswer522") }}
            <a href="https://mail.google.com/mail/u/0/#inbox?compose=new" target="_blank" rel="noopener noreferrer"
              class="text-blue-500">{{ $t("message.loginComponent.login.rrhh") }}</a>
            {{ $t("message.loginComponent.login.helpAnswer533") }}<br /> <br />
            {{ $t("message.loginComponent.login.helpAnswer544") }}
          </div>
        </div>
      </div>
    </div>
  </zt-modal>
</template>

<script>
import { useWindowResize } from "@sichern/ui-elements";

export default {
  name: "ForgotPasswordHelpModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      windowResize: useWindowResize(this),
    };
  },
  computed: {
    isMobile() {
      return this.windowResize.width < 1024;
    },
  },
  methods: {
    closeDialog() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../../../public/assets/scss/_config.scss";

.modal-help-body {
  overflow-y: auto;

  @media all and (max-width: 1024px) {
    height: 100%;
  }
}
</style>
